import getLoggedAtWorkoutUtil from '../../../../../modules/workout/model/utils/get-logged-at'
import getPlannedAtWorkoutUtil from '../../../../../modules/workout/model/utils/get-planned-at'

function getLoggedOrPlannedAtWorkoutUtil (workout) {
  return getLoggedAtWorkoutUtil(workout) || getPlannedAtWorkoutUtil(workout)
}

export { getLoggedOrPlannedAtWorkoutUtil }
